<template>
    <div class="table-responsive product-create">
        <table class="table table-bordered table-custom mb-0">
            <thead>
            <tr>
                <th></th>
                <th></th>
                <th>Company Name</th>
                <th>Address</th>
                <th>Details</th>
                <th>Contact Name</th>
                <th>Email</th>
                <th>Status</th>
            </tr>
            </thead>
            <template v-if="vendorData.vendors != null">
                <template v-for="(vendor, index) in vendorData.vendors.data">
                    <tr :id="vendor.id" v-on:click="selectVendor(vendor)">
                        <td>{{ getSLNo(index)}}</td>
                        <td><input name="selected_vendor" :value="vendor.id" type="radio" class="check-box" :checked="selectedVendor == vendor.id"></td>
                        <td><router-link :to="{name: 'vendorDetails', params: {id: vendor.id}}" target="_blank">{{vendor.company_name}}</router-link></td>
                        <td>{{vendor.address}}</td>
                        <td><router-link :to="{name: 'vendorDetails', params: {id: vendor.id}}" target="_blank" class="btn details-btn"><i class="fa fa-eye" aria-hidden="true"></i> Details</router-link></td>
                        <td>{{vendor.contacts && vendor.contacts.length > 0 ? vendor.contacts[0].contact_name : ''}}</td>
                        <td>{{vendor.contacts && vendor.contacts.length > 0 ? vendor.contacts[0].email : ''}}</td>
                        <td><a href="javascript:void(0)" :class="[vendor.status=='1' ? 'active':'inactive']">{{(vendor.status=='1')?'Active':'Inactive'}}</a></td>
                    </tr>
                </template>

            </template>
        </table>

        <div class="btnrow text-left" v-if="vendorData.vendors != null && vendorData.vendors.data.length">
            <template>
                <div class="overflow-auto">
                    <b-pagination
                        v-model="current_page"
                        :total-rows="total"
                        :per-page="per_page"
                    ></b-pagination>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import {mapActions, mapGetters, mapState} from "vuex";

export default {
    name: "Vendors",
    props: ['selectedVendor', 'search_filter', 'bus'],
    created() {
        if(localStorage.getItem('token')){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        }
    },
    mounted() {
        if(this.search_filter) {
            this.filterForm.search_filter = this.search_filter;
        }
        this.getVendors();
        this.bus.$on('getVendors', this.getVendors)
    },
    data(){
        return {
            vendorData: {
                vendors: null,
                config: null,
            },
            current_page:1,
            per_page:10,
            total:0,
            filterForm: {
                search_filter: null,
                status_filter: '1'
            }
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading'
        ]),
        selectVendor(c) {
            // this.selectedVendor = c.id;

            this.$emit('selectVendor', c)
        },
        getVendors() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('vendors.index',{
                page: this.current_page,
                search_filter:this.filterForm.search_filter,
                status_filter:this.filterForm.status_filter
            } ), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.vendorData = data.data;
                        this.current_page = data.data.vendors.current_page;
                        this.per_page = data.data.vendors.per_page;
                        this.total = data.data.vendors.total;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        getSLNo(index) {
            return Number(this.vendorData.config['start_from']) + index;
        }
    },
    watch: {
        current_page: {
            handler: function(value) {
                if(value != 1){
                    this.getVendors();
                }
            }
        },
        search_filter: {
            handler: function (value) {
                this.filterForm.search_filter = value;
            }
        }
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading',
        ])
    }
}
</script>

<style scoped>

</style>
